import { render, staticRenderFns } from "./DeviceTestDetail.vue?vue&type=template&id=ebb00c98&scoped=true&"
import script from "./DeviceTestDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceTestDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTestDetail.vue?vue&type=style&index=0&id=ebb00c98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb00c98",
  null
  
)

export default component.exports